import { Flex, Text } from '@chakra-ui/react';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { openFile } from 'src/utils/file';

interface IProps {
  files: ISubmissionFile[];
  displayFieldName?: 'referenceName' | 'name';
}

const FileListDisplay: React.FC<IProps> = ({
  files = [],
  displayFieldName = 'referenceName'
}) => {
  if (!files.length) {
    return null;
  }

  return files.map(file => (
    <Flex justifyContent="space-between" key={file[displayFieldName]}>
      <Flex gap={2} alignItems="center">
        <FontAwesomeIcon icon={faFile} />
        <Text textStyle="textBody">{file[displayFieldName]}</Text>
        <ButtonText onClick={() => openFile(file.url)}>View</ButtonText>
      </Flex>
    </Flex>
  ));
};

export default FileListDisplay;
